import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

export default function ({ roomName, open, onConfirm, onCancel }) {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                    Are you sure you want to delete{' '}
                    <u>
                        <b>{roomName}</b>
                    </u>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color='primary'>
                    Cancel
                </Button>
                <Button onClick={onConfirm} color='primary'>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
